ACC.salesforce = {
 createSalesForceObject: function(formType,formId,modalId,buttonId,showSuccessModal){
        var formValues=$(formId).serializeArray();
        var fields= new Map();
        $.each(formValues,function(i,field){
            fields.set(field.name,field.value)
        });
        let marketingCookies=ACC.cookie.getFormattedCookies(ACC.cookie.getMatchingCookies('utm_'));
        fields.set('leadUTM',marketingCookies)
        var dataObject = {
        formName : formType,
        fields : Object.fromEntries(fields)
        };
              $.ajax({
                   url: ACC.config.encodedContextPath + '/salesforce/create',
                   type: 'POST',
                   contentType : 'application/json',
                   data:  JSON.stringify(dataObject),
                   success: function(data) {
                            if(data){
                             $(formId)[0].reset();
                             $(buttonId).removeAttr('disabled');
                             $(modalId).modal('hide');
                             if(showSuccessModal)
                             {
                                $("#thankuModal").modal('show');
                             }
                             if($('#reportButton').length){
                                var url =$('#acimaNewsDownloadReportUrl').attr('data-value');
                                if(url){
                                window.open(url, '_blank');
                                }

                             }
                            }
                        }
               })
    }

 }
